import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {Avatar} from '@components/common/base/avatar'
import {ToolTipText} from '@components/common/base/tooltip/tooltip-text'
import {useMainMenuStore} from '@components/main-menu/main-menu-store'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {tooltipOffsetX} from '../components/menu-icon-button-with-tooltip'
import {profilePage} from '../constants'
import {goto} from '../handlers/main-handlers'

const TwAvatarContainerCollapsed = tw.div<{$active?: boolean}>`
  cursor-pointer
  p-4
  rounded-4
  ${p => {
    if (p.$active) {
      return 'bg-panel-background-active'
    } else {
      return 'hover:bg-panel-background-hover'
    }
  }}
`

const TwAvatarContainer = tw.div`
  py-8
  w-full

  border-0
  border-t-1
  border-b-1
  border-solid
  border-panel-line-base
`

export const ProfileCollapsedMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const active = state.currentPage === profilePage

  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    forceUpdate
  )

  const gotoProfile = () => {
    goto(profilePage)
    void Tracking.send(TrackingEvent.leftPanelProfileClick)
  }

  return (
    <ToolTipText
      text={Lang.msg.menu.profileHint}
      offsetX={tooltipOffsetX}
      offsetY={5}
    >
      <TwAvatarContainer className="mb-8">
        <TwAvatarContainerCollapsed $active={active} onClick={gotoProfile}>
          <Avatar
            hideStatus
            hideOutline
            hideHint
            size={24}
            userId={globals.currentUserId}
          />
        </TwAvatarContainerCollapsed>
      </TwAvatarContainer>
    </ToolTipText>
  )
})
